import { formatTime, isEventPast, isWorkshopPast, workshopDateRange, toLocalDateStr } from "./calendarUtils";

export function EventPill({ event, onClick, compact, adminMode, cancelled, dateStr }) {
  const isOnline  = event.venue === "venue_online";
  const isHybrid  = event.isHybrid === true;
  const isPrivate = event._isPrivate;
  const past      = !adminMode && dateStr ? isEventPast(dateStr, event.time, event.duration) : false;
  const clickable = adminMode || (!cancelled && !past);

  if (isPrivate) {
    return (
      <div
        className="event-pill private-pill"
        style={{ cursor: adminMode ? "pointer" : "default" }}
        onClick={(e) => { e.stopPropagation(); if (adminMode && onClick) onClick(event); }}
      >
        <span className="event-time">{formatTime(event.time)}</span>
        {" "}
        <span className="event-title">{adminMode ? "Private" : "Private"}</span>
      </div>
    );
  }

  return (
    <button
      onClick={() => { if (clickable) onClick(event); }}
      className={`event-pill ${isHybrid?"hybrid":isOnline?"online":"inperson"} ${compact?"compact":""} ${cancelled?"cancelled-pill":""} ${adminMode?"admin-pill":""} ${past && !adminMode?"past-pill":""}`}
      style={!clickable ? {cursor:"default", pointerEvents:"none"} : {}}
    >
      <span className="event-time">{formatTime(event.time)}</span>
      {!compact && <span className="event-title">{event.title}</span>}
      <span className={`event-tag ${isOnline?"tag-online":"tag-studio"}`}>
        {cancelled?"Cancelled":isOnline?"Online":"Studio"}
      </span>
    </button>
  );
}

export function WorkshopBanner({ workshop, dateStr, onClick, adminMode }) {
  const allDates  = workshopDateRange(workshop);
  const isFirst   = allDates[0] === dateStr;
  const isLast    = allDates[allDates.length - 1] === dateStr;
  const dayData   = workshop.days.find(d => d.date === dateStr);
  const sessCount = dayData?.sessions?.length ?? 0;
  const past      = !adminMode && isWorkshopPast(workshop);

  return (
    <button
      onClick={() => { if (past && !adminMode) return; onClick(workshop); }}
      className={`workshop-banner ${isFirst?"ws-first":""} ${isLast?"ws-last":""} ${past && !adminMode?"past-pill":""}`}
      style={past && !adminMode ? {cursor:"default", pointerEvents:"none"} : {}}
      title={workshop.title}
    >
      {isFirst
        ? <span className="ws-banner-title">{workshop.title}</span>
        : sessCount > 0 && <span className="ws-banner-sessions">{sessCount} session{sessCount!==1?"s":""}</span>
      }
    </button>
  );
}